// View-model + display helpers for lesson Q&A. Pure and SDK-free.
//
// Anonymity model: a question doc that students can read NEVER contains the
// author's uid/email. When `isAnonymous` is true, `authorName` is null in the
// stored doc too - identity lives only in a private subdoc readable by admin.
// `questionAuthorLabel` is the last line of defense: it refuses to show a name
// for an anonymous question regardless of what's in the view object.

export type QuestionView = {
  id: string;
  text: string;
  imageUrl?: string;
  isAnonymous: boolean;
  /** Display name for non-anonymous questions; null when anonymous or unknown. */
  authorName: string | null;
  createdAt: Date;
  answerText: string | null;
  answeredAt: Date | null;
};

export function questionAuthorLabel(q: QuestionView): string {
  if (q.isAnonymous) return "นักเรียนนิรนาม";
  return q.authorName || "นักเรียน";
}

/** Trim text for notification snippets; appends … when cut. */
export function excerpt(text: string, max = 120): string {
  const t = text.trim();
  return t.length <= max ? t : t.slice(0, max - 1).trimEnd() + "…";
}

/** Unanswered first (so the instructor's own queue and the class see open
 *  questions on top), newest-first within each group. Non-mutating. */
export function sortQuestions(questions: QuestionView[]): QuestionView[] {
  return [...questions].sort((a, b) => {
    const aAnswered = a.answerText ? 1 : 0;
    const bAnswered = b.answerText ? 1 : 0;
    if (aAnswered !== bAnswered) return aAnswered - bAnswered; // unanswered (0) first
    return b.createdAt.getTime() - a.createdAt.getTime(); // newest first
  });
}
